module.exports = __webpack_public_path__ + "img/banner9.c1285f60.png";